import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IEntityInfoView } from '@components/widgets/entity-info/EntityInfoFields';

export const entityView: IEntityInfoView = {
  name: 'section1',
  title: 'Brand Details',
  iconUrl: '',
  sections: [
    {
      name: 'details',
      title: '',
      properties: {},
    },
  ],
  socialMedia: {
    facebook: '',
    linkedIn: '',
    twitter: '',
  },
};

export const getHeaders = (
  setAddDrawerOpen: (open: true) => void,
  onEditBrand: (row: any) => void
): Record<string, EnhancedTableHeader> => ({
  Code: {
    name: 'Code',
    title: 'Code',
    type: EnhancedTableHeaderType.Clickable,
    callback: (payload) => {
      setAddDrawerOpen(true);
      if (payload && payload.columns) onEditBrand(payload.columns);
    },
  },
  BrandCode: {
    name: 'BrandCode',
    title: 'Brand Code',
    type: EnhancedTableHeaderType.Text,
  },
  Title: {
    name: 'Title',
    title: 'Title',
    type: EnhancedTableHeaderType.Text,
  },
});

export const getModelHeaders = (
  setAddDrawerOpen: (open: boolean) => void,
  onEdit: (row: any) => void
): Record<string, EnhancedTableHeader> => ({
  Brand: {
    name: 'Brand',
    title: 'Brand',
    type: EnhancedTableHeaderType.Text,
  },
  Code: {
    name: 'Code',
    title: 'Code',
    type: EnhancedTableHeaderType.Clickable,
    callback: (payload: any) => {
      setAddDrawerOpen(true);
      if (payload && payload.columns) onEdit(payload.columns);
    },
  },
  ModelCode: {
    name: 'ModelCode',
    title: 'Model Code',
    type: EnhancedTableHeaderType.Text,
  },
  Title: {
    name: 'Title',
    title: 'Title',
    type: EnhancedTableHeaderType.Text,
  },
});
